module.exports = __webpack_public_path__ + "static/media/PropertyBulkUpload.7fc90bff.xlsx";